import type { ToolBadgeSpec } from '../types.js';

import { extractSingleUrl, faviconUrl, readArray, readField, readString } from '../extractors.js';

export const webSearchSpec: ToolBadgeSpec = {
  toolName: 'webSearch',
  icon: 'travel_explore',
  label: (_, active) => (active ? 'Searching the web' : 'Searched the web'),
  resultNoun: { singular: 'result', plural: 'results' },
  extractResults: (toolCall) => {
    const arr = readArray(readField(toolCall.output, 'results'));
    if (!arr) return undefined;
    const items = [];
    for (const [index, entry] of arr.entries()) {
      const url = readString(readField(entry, 'url'));
      if (!url) continue;
      const title = readString(readField(entry, 'title')) ?? url;
      const snippet = readString(readField(entry, 'snippet'));
      items.push({
        key: `${url}-${index}`,
        title,
        subtitle: snippet ?? url,
        href: url,
        iconUrl: faviconUrl(url),
        iconVariant: 'logo' as const,
      });
    }
    return { items };
  },
};

export const webScraperSpec: ToolBadgeSpec = {
  toolName: 'webScraper',
  icon: 'travel_explore',
  label: (_, active) => (active ? 'Searching the web' : 'Searched the web'),
  activitySummary: { key: 'webSearch' },
  resultNoun: { singular: 'page', plural: 'pages' },
  extractResults: (toolCall) => extractSingleUrl(toolCall.output),
};

export const getUrlContentSpec: ToolBadgeSpec = {
  toolName: 'getUrlContent',
  icon: 'travel_explore',
  label: (_, active) => (active ? 'Reading web page' : 'Read web page'),
  activitySummary: { key: 'webPageRead' },
  resultNoun: { singular: 'page', plural: 'pages' },
  extractResults: (toolCall) => extractSingleUrl(toolCall.output),
};
